module.exports = __webpack_public_path__ + "img/Mstorybg403.818721c5.png";